/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveOfferRequest
 */
export interface ApproveOfferRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ApproveOfferRequest
     */
    approve: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApproveOfferRequest
     */
    copies: number;
}

/**
 * Check if a given object implements the ApproveOfferRequest interface.
 */
export function instanceOfApproveOfferRequest(value: object): value is ApproveOfferRequest {
    if (!('approve' in value) || value['approve'] === undefined) return false;
    if (!('copies' in value) || value['copies'] === undefined) return false;
    return true;
}

export function ApproveOfferRequestFromJSON(json: any): ApproveOfferRequest {
    return ApproveOfferRequestFromJSONTyped(json, false);
}

export function ApproveOfferRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveOfferRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'approve': json['approve'],
        'copies': json['copies'],
    };
}

export function ApproveOfferRequestToJSON(json: any): ApproveOfferRequest {
    return ApproveOfferRequestToJSONTyped(json, false);
}

export function ApproveOfferRequestToJSONTyped(value?: ApproveOfferRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approve': value['approve'],
        'copies': value['copies'],
    };
}

